// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "05498c5f67c49c09d25a" + "/css/" + chunkId + ".css";
};